module.exports = __webpack_public_path__ + "static/media/Racefiets-fietsmaat.4fc79d10.png";